import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Notification } from '@app-types/notification';
import { getTimeAgo } from '@app-utils/date';

@Component({
  selector: 'app-notification-panel',
  templateUrl: './notification-panel.component.html',
  styleUrls: ['./notification-panel.component.scss'],
  imports: [MatButton, MatIconButton, MatIcon, TranslateModule],
})
export class NotificationPanelComponent {
  @Input() notifications: Notification[] = [];
  @Output() markAsRead = new EventEmitter<number>();
  @Output() markAllAsRead = new EventEmitter<void>();
  @Output() closeNotifications = new EventEmitter<void>();
  @Output() openDialogMessage = new EventEmitter<Notification>();

  constructor() {}

  timeAgo(date: Date): string {
    return getTimeAgo(date);
  }
}
